module.exports = __webpack_public_path__ + "static/img/10013 (1).d06fe65.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10013 (1).webp
// module id = M/dR
// module chunks = 14